function has_descriptions(section) {
  return Array.isArray(section?.descriptions) && section.descriptions.length > 0;
}

function has_table_rows(section) {
  return Array.isArray(section?.table?.rows);
}

function get_table_cells(section) {
  return (section?.table?.rows || []).flatMap((row) => Array.isArray(row) ? row : []);
}

function split_numbered_matches(cleaned) {
  return (cleaned.match(/(?:^|\s)(\d+\.\s.*?)(?=(?:\s\d+\.\s)|$)/g) || [])
    .map((item) => item.replace(/^\s*\d+\.\s*/, '').trim())
    .filter(Boolean);
}

function split_numbered_lines(cleaned) {
  return cleaned
    .split('\n')
    .map((line) => line.replace(/^\s*\d+\.\s*/, '').trim())
    .filter(Boolean);
}
function split_cleaned_text(cleaned) {
  return cleaned.includes('\n') ? split_numbered_lines(cleaned) : [cleaned];
}

const methods = {
    collect_section_table_text(section) {
      return (section.table?.rows || [])
        .flatMap((row) => Array.isArray(row) ? row : [])
        .map((cell) => this.strip_html_tags(cell))
        .filter(Boolean)
        .join(' ');
    },

    extract_section_text(keywords = []) {
      const section = this.find_matching_section(keywords);
      if (!section) return '';

      if (has_descriptions(section)) {
        return this.strip_html_tags(section.descriptions.join(' '));
      }

      if (has_table_rows(section)) return this.collect_section_table_text(section);

      return '';
    },
    push_expanded_section_items(items, value) {
      const expanded = this.expand_numbered_text(value);
      if (expanded.length) items.push(...expanded);
    },

    extract_section_list(keywords = []) {
      const section = this.find_matching_section(keywords);
      if (!section) return [];
      const items = [];
      this.push_section_description_items(items, section);
      if (!items.length) this.push_section_table_items(items, section);
      return items.filter(Boolean);
    },
    push_section_description_items(items, section) {
      if (!has_descriptions(section)) return;
      section.descriptions.forEach((description) => {
        this.push_expanded_section_items(items, description);
      });
    },
    push_section_table_items(items, section) {
      if (!has_table_rows(section)) return;
      get_table_cells(section).forEach((cell) => {
        this.push_expanded_section_items(items, cell);
      });
    },
    find_matching_section(keywords = []) {
      const normalized_keywords = keywords.map((keyword) => String(keyword).toLowerCase());
      const sections = this.flatten_sections(this.form_detail?.sections || []);
      return sections.find((item) => {
        const title = String(item?.title || '').toLowerCase();
        return normalized_keywords.some((keyword) => title.includes(keyword));
      }) || null;
    },

    expand_numbered_text(value) {
      const cleaned = this.strip_html_tags(value || '')
        .replace(/\r/g, '\n')
        .replace(/\u00a0/g, ' ')
        .trim();
      if (!cleaned) return [];

      const numbered_matches = split_numbered_matches(cleaned);
      if (numbered_matches.length) return numbered_matches;
      return split_cleaned_text(cleaned);
    },

    flatten_sections(sections = []) {
      const flattened = [];
      (sections || []).forEach((section) => {
        if (!section || typeof section !== 'object') return;
        flattened.push(section);
        (section.subsections || []).forEach((subsection) => {
          if (subsection && typeof subsection === 'object') {
            flattened.push(subsection);
          }
        });
      });
      return flattened;
    },

    // ---------------------------------------------------
    // MODE SWITCHING
};

export default methods;

